import { getLocalStorage, setLocalStorage } from '../common/common';
import { App } from '@capacitor/app';
import axios from 'axios';
import appConfig from '../config/config';
const url = appConfig.apiLoc;

export const postAppOneSignalId = async (token, user_master_id) => {
  const { Capacitor } = await import('@capacitor/core');
  const CurrentPlatform = Capacitor.getPlatform();
  if (CurrentPlatform === 'web') {
    return;
  }
  let userId = getLocalStorage('app_one_signal_player_id', '');
  // console.log('device_userId', JSON.stringify(userId));
  if (userId) {
    const CurrentPlatform = Capacitor.getPlatform();
    let appVersion = '';
    App.getInfo().then((deviceInfo) => {
      appVersion = deviceInfo ? deviceInfo.version : '';
      // console.log('device info===>', JSON.stringify(deviceInfo));
    })
    .catch(e=> console.log(e));
    let formData = new FormData();
    formData.append('user_master_id', user_master_id);
    formData.append('onesignal', userId);
    formData.append('os', CurrentPlatform);
    formData.append('appversion', appVersion);
    formData.append('browser', 'app');
    // console.log("my from data ==>", formData);
    axios
      .post(`${url}Authrcommon/getOnesignal`, formData, { headers: { Authorization: token } })
      .then((response) => {
        // console.log('ONE_SIGNAL_ID_SUCCESSFULLY_POSTED response ', response);
        // console.log('ONE_SIGNAL_ID_SUCCESSFULLY_POSTED response ===>', JSON.stringify(response));
        if (response.status == 200) {
          // console.log('ONE_SIGNAL_ID_SUCCESSFULLY_POSTED');
        }
      })
      .catch((error) => {
        // console.log('ERROR', error);
      });
  }
};
